import { createBrowserRouter } from "react-router-dom";
// import Sidebar from "../components/sidebar/Sidebar";
import SignIn from "../pages/signin/Signin";
import Signup from "../pages/signup/Signup";
import HomePage from "../pages/HomePage/HomePage";
import Sidebar from "../components/sidebar/Sidebar";
import WorkSpace from "../pages/auth/home/Page";
import Reports from "../pages/auth/reports/Page";
import Videos from "../pages/auth/videos/Page";
// import NotFound from "../commonComponents/errorPage/NotFound";
import Terms from "../pages/terms/Terms";
import Disclaimer from "../pages/HomePage/Disclaimer";
import ChangePass from "../pages/changePass/ChangePass";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import ForgetPass from "../pages/forgetPassword/ForgetPass";
import ProtectedRoutes from "./ProtectedRoutes";
import OnboardDevice from "../pages/onboardDevice/OnboardDevice";
const router = createBrowserRouter([
  // 👇👇👇👇👇👇PUBLIC ROUTE👇👇👇👇👇👇
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/signin",
    element: <SignIn />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/forget-password",
    element: <ForgetPass />,
  },
  {
    path: "/reset-password/:id",
    element: <ResetPassword />,
  },
  {
    path: "/device-onboard",
    element: <OnboardDevice />,
  },

  // 👇👇👇👇👇👇PRIVATE ROUTE👇👇👇👇👇👇
  {
    path: "/auth",
    element: (
      <ProtectedRoutes>
        <Sidebar />
      </ProtectedRoutes>
    ),
    children: [
      {
        path: "workspace",
        element: (
          <ProtectedRoutes>
            <WorkSpace />
          </ProtectedRoutes>
        ),
      },
      {
        path: "reports",
        element: (
          <ProtectedRoutes>
            <Reports />
          </ProtectedRoutes>
        ),
      },
      {
        path: "videos",
        element: (
          <ProtectedRoutes>
            <Videos />
          </ProtectedRoutes>
        ),
      },
      {
        path: "change-password",
        element: (
          <ProtectedRoutes>
            <ChangePass />
          </ProtectedRoutes>
        ),
      },
    ],
  },
]);

export default router;
